export default __webpack_public_path__ + "static/media/veme-blockchain-app-developed.e1fbdcb0.png";